import { Flex } from 'antd';
import { PhotoDisplay } from './PhotoDisplay';
import { CustomUpload } from '../CustomUpload';
import { useFilesByIds } from '../../context/FileManagementContext';

export const PhotoSection = ({
  fileBusinessObjects = [], // [{ fileId, addedAt, ... }]
  uploadPhoto,
  removePhoto,
  allowMultiple = false,
}) => {
  // 取得所有 fileId
  const fileIds = fileBusinessObjects.map(obj => obj.fileId);
  // 查詢檔案細節
  const files = useFilesByIds(fileIds);
  // 組合業務屬性與檔案細節
  const photoFiles = fileBusinessObjects.map(obj => {
    const file = files.find(f => f.id === obj.fileId);
    return { ...obj, ...file };
  });

  // 🔄 處理照片上傳
  const handlePhotoFileUpload = ({ file, fileSource = "local" }) => {
    // 如果不允許多張照片且已有照片，先刪除舊的
    if (!allowMultiple && photoFiles.length > 0) {
      photoFiles.forEach(file => {
        removePhoto(file.id);
      });
    }
    // 上傳新照片
    uploadPhoto({
      file,
      fileSource,
    });
  };

  // 🔄 處理照片移除
  const handlePhotoRemove = (id) => {
    removePhoto(id);
  };

  return (
    <Flex vertical className='gap-2'>
      {/* 上傳/選擇控件區域 */}
      <CustomUpload
        type="image"
        text={photoFiles.length > 0 ? "替換照片" : "上傳照片"}
        onChange={info => handlePhotoFileUpload({ file: info.file, fileSource: "local" })}
      />

      {/* 照片預覽區域 */}
      {photoFiles.length > 0 && (
        <div className="mt-4">
          {allowMultiple ? (
            <div className="grid grid-cols-1 gap-4">
              {photoFiles?.map(file => (
                <div key={file.id || file.fileId || file.uid}>
                  <PhotoDisplay
                    file={file}
                    onRemove={() => handlePhotoRemove(file.id)}
                  />
                </div>
              ))}
            </div>
          ) : (
            /* 🔄 只顯示最新的一張照片 */
            photoFiles.slice(-1).map(file => (
              <div key={file.id || file.fileId || file.uid}>
                <PhotoDisplay
                  file={file}
                  onRemove={() => handlePhotoRemove(file.id)}
                />
              </div>
            ))
          )}
        </div>
      )}
    </Flex>
  );
}; 